/*global $*/
/*eslint no-undef: "error"*/

export default class CompanyFaq {
	classItem = 'company-faq--item'
	classButton = 'company-faq--button'
	classBlock = 'company-faq--block'

	classOpen = 'company-faq-item---open'

	constructor () {
		let self = this

		$(`.${self.classButton}`).click(function () {
			$(this).closest(`.${self.classItem}`).toggleClass(self.classOpen)

			if ($(this).closest(`.${self.classItem}`).hasClass(self.classOpen)) {
				$(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).show(500)
			} else {
				$(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).hide(500)
			}
		})
	}
}
